export const unsupportedNodeAttribute = {
  toDOM() {
    return ['span'];
  },

  attrs: {
    type: {},
    unsupported: {}
  }
};